var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplymainsalesforcemobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 134,
    viewBox: "0 0 146 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M128.324 67.704c0 24.778-15.18 36.48-33.896 26.169C75.713 83.56 60.551 55.099 60.551 30.34c0-24.778 15.18-36.48 33.896-26.168 18.716 10.312 33.877 38.755 33.877 63.532z",
    fill: "url(#7eeb3ch6ba)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M79.04 15.603c-4.444-2.456-8.848-3.72-12.97-3.738-4.102-.018-7.845 1.228-11.002 3.666-3.157 2.438-5.652 5.996-7.354 10.492-1.701 4.497-2.59 9.86-2.59 15.748L79.04 60.444v-44.84z",
    fill: "url(#esjgwuq5yb)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.707 35.559c0 8.867 1.985 18.637 5.71 28.064 3.723 9.427 9.017 18.095 15.198 24.904 6.182 6.808 13.007 11.45 19.586 13.345 6.578 1.897 12.609.957 17.354-2.709 4.745-3.666 7.959-9.878 9.282-17.842 1.305-7.982.643-17.373-1.928-26.98-2.571-9.608-6.9-19.017-12.477-27.018-5.577-8-12.118-14.248-18.83-17.932V54.25L52.708 35.559z",
    fill: "url(#gwwf9z0vzc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M62.255 31.008 5.995 0l.018 27.992 51.288 28.28 4.972 7.026-.019-32.29z",
    fill: "url(#frq8xwl9vd)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.908V3.305l21.23 11.72v7.603L0 10.908z",
    fill: "#7ECEFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m47.79 29.852-12.327-6.79v2.456l12.326 6.79v-2.456zM47.79 34.782 24.025 21.69v2.455L47.789 37.24v-2.457zM47.79 39.694 18.996 23.82v2.456L47.79 42.17v-2.475z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.833 34.096c0 2.312 1.437 4.967 3.195 5.942 1.758.975 3.195-.109 3.195-2.42 0-2.312-1.437-4.967-3.195-5.942-1.777-.975-3.195.109-3.195 2.42z",
    fill: "#7ECEFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m84.88 74.332 56.242 31.026.019 28.01-51.288-28.281-4.953 1.553-.02-32.308z",
    fill: "url(#3paf8wjr8e)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.77 110.289v-7.603l21.23 11.72v7.603l-21.23-11.72z",
    fill: "#7ECEFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m99.342 89.14 12.326 6.79v2.457l-12.326-6.79V89.14zM99.343 94.053l22.251 12.262v2.456l-22.25-12.262v-2.456zM99.345 98.983l28.792 15.874v2.457l-28.773-15.875-.019-2.456z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.32 90.026c0 2.312-1.436 3.395-3.195 2.42-1.758-.975-3.194-3.63-3.194-5.942 0-2.311 1.436-3.395 3.194-2.42 1.759.976 3.195 3.63 3.195 5.942z",
    fill: "#7ECEFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M45.316 60.462 77 77.926V134l-31.684-17.463V60.462z",
    fill: "url(#hhk9gtj2hf)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m48.433 93.746 25.446 14.032v2.456L48.433 96.202v-2.456zM50.21 99.525l21.872 12.064v2.456l-21.873-12.064v-2.456z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.453 109.547 37.41 97.394v6.266l22.043 12.154v-6.267zM64.766 82.513c0 2.709-1.645 3.991-3.668 2.871-2.023-1.137-3.667-4.244-3.667-6.97 0-2.71 1.644-3.992 3.667-2.872 2.023 1.138 3.668 4.262 3.668 6.97zM61.081 87.57c-3.27-1.824-5.973-.109-6.446 3.81-.076.686.454 1.59 1.115 1.95l10.663 5.96c.661.361 1.19.072 1.115-.704-.473-4.48-3.176-9.192-6.447-11.016z",
    fill: "#7ECEFA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m27.675 55.876-8.09-4.461v-2.6l8.09 4.46c.662.361 1.626 1.102 2.44 2.24.888 1.21 1.512 2.745 1.512 4.406 0 1.842-.492 2.89-1.418 3.178-.87.271-1.91-.198-2.534-.541l-3.327-1.843-.019-.018c-.283-.162-.737-.325-1.096-.216-.303.09-.624.361-.624 1.39 0 1.03.34 1.644.605 2.023.34.47.794.795 1.078.94l.037.017L34.5 70.468v2.6l-10.114-5.58c-.7-.343-1.701-1.084-2.571-2.24-.945-1.282-1.588-2.89-1.588-4.677 0-1.788.643-2.69 1.57-2.944.869-.234 1.87.109 2.57.506l3.29 1.824c.472.27.831.38 1.077.307.19-.054.53-.307.53-1.625 0-.867-.284-1.427-.568-1.788-.34-.488-.756-.83-1.02-.975z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.059 50.855c0 2.33-1.437 3.432-3.195 2.474-1.758-.975-3.195-3.648-3.195-5.995 0-2.33 1.437-3.431 3.195-2.474 1.758.975 3.195 3.666 3.195 5.995zM38.64 73.971c0 2.33-1.436 3.431-3.194 2.474-1.758-.975-3.195-3.648-3.195-5.995 0-2.33 1.437-3.432 3.195-2.475 1.758.976 3.195 3.666 3.195 5.996z",
    fill: "#7ECEFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7eeb3ch6ba",
    x1: 135.127,
    y1: 29.734,
    x2: 73.542,
    y2: 61.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "esjgwuq5yb",
    x1: 93.454,
    y1: 25.849,
    x2: 56.135,
    y2: 44.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gwwf9z0vzc",
    x1: 111.154,
    y1: 38.338,
    x2: 84.686,
    y2: 66.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "frq8xwl9vd",
    x1: 49.986,
    y1: 19.793,
    x2: 21.959,
    y2: 42.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3paf8wjr8e",
    x1: 109.044,
    y1: 75.245,
    x2: 115.69,
    y2: 131.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hhk9gtj2hf",
    x1: 80.386,
    y1: 65.405,
    x2: 54.148,
    y2: 112.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplymainsalesforcemobile);
export default __webpack_public_path__ + "static/media/Apply main salesforce mobile.e238b0254398ad2f1bb992464f9363cf.svg";
export { ForwardRef as ReactComponent };